import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '../app-config/app-config.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { ThemeHelpersService } from 'src/app/@theme/helpers/theme-helpers/theme-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    jwtHelper = new JwtHelperService();

    constructor(
        private http: HttpClient,
        private appConfig: AppConfigService,
        private router: Router,
        private themeHelper: ThemeHelpersService,
    ) { }

    /**
     * Authentiate and login a user
     * @param loginData - the login data object.
     */
    login(loginData: object) {
        return this.http.post(this.appConfig.getConfig('server', 'commonendpoint') + '/m1287368', JSON.stringify(loginData), { headers: this.loadHeaders(false) });
    }

    /** Logout a user out of the System and deactivate the user's session */
    logout() {
        this.appConfig.clearStorage();
        this.router.navigate(['/']);
    }

    /** Check if the auth token exists and has not expired */
    isAuthenticated() {
        return this.loadToken() && !this.jwtHelper.isTokenExpired(this.loadToken());
    }

    /** Stores the session data into localstorage */
    storeLoginData(data: any, user: any) {
        this.appConfig.setLocalConfig('employeeId', user['employeeId']);
        this.appConfig.setLocalConfig('employeeName', user['name']);
        this.appConfig.setLocalConfig('sphereTypeId', user['sphereTypeId']);
        this.appConfig.setLocalConfig('sphereType', user['sphereType']);
        this.appConfig.setLocalConfig('sphereId', data['sphereId']);
        this.appConfig.setLocalConfig('sphere', data['sphere']);
        this.appConfig.setLocalConfig('verticalId', data['verticalId']);
        this.appConfig.setLocalConfig('verticalName', data['verticalName']);
        if (user['token']) {
            this.appConfig.setLocalConfig('token', user['token']);
        }
        if (user['userToken']) {
            this.appConfig.setLocalConfig('userToken', user['userToken']);
        }
    }

    /** Returns the auth token from local storage */
    loadToken() {
        return this.appConfig.getLocalConfig('token') ? 'Bearer ' + this.appConfig.getLocalConfig('token') : null;
    }

    /** Returns the auth token from local storage */
    loadUserToken() {
        return this.appConfig.getLocalConfig('userToken') ? this.appConfig.getLocalConfig('userToken') : null;
    }

    /**
     * Returns a header object based on the provided parameters
     * @param includeToken - Wether or not to include the auth token in the header
     * @param contentType - the content type to specify in the header
     */
    loadHeaders(includeToken: boolean = true, contentType: string = 'application/json') {
        const headers = {};
        if (this.themeHelper.valCheck(contentType)) {
            headers['Content-Type'] = contentType;
        }
        if (includeToken) {
            headers['Authorization'] = this.loadUserToken();
        }
        return headers;
    }

    /**
     * Parses the stored auth token and extract the needed data based on key supplied in the paramter
     * @param key - the key to use to get the value from the token object.
     */
    getTokenData(key: string = '_id') {
        const token = this.jwtHelper.decodeToken(this.loadToken());
        return token[key];
    }
}
